import { useMutation, useQueryClient } from '@tanstack/vue-query';
import { createFolder, moveVulnerabilityToFolder } from './vulnerability.endpoints';
import { foldersQueryKeys } from '@/_core/entities/report/api/folders.queryKeys';
import type { TCreateFolderPayload, TMoveVulnerabilityToFolderPayload } from '../models/types';

export function useCreateFolder() {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: (payload: TCreateFolderPayload) => createFolder(payload),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: foldersQueryKeys.all });
    },
  });
}

export function useMoveVulnerabilityToFolder() {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: (payload: TMoveVulnerabilityToFolderPayload) => moveVulnerabilityToFolder(payload),
    onSuccess: (_data, payload) => {
      queryClient.invalidateQueries({ queryKey: ['vulnerability', payload.vulnerabilityId] });
      queryClient.invalidateQueries({ queryKey: foldersQueryKeys.all });
      queryClient.invalidateQueries({ queryKey: ['complianceSummary'] });

      if ('jobId' in payload) {
        queryClient.invalidateQueries({ queryKey: ['singleScanReport', payload.jobId] });
        queryClient.invalidateQueries({ queryKey: ['singleScanPage', payload.jobId] });
        return;
      }

      queryClient.invalidateQueries({ queryKey: ['versionReport', payload.integrationId] });
      queryClient.invalidateQueries({ queryKey: ['appVersionPage', payload.integrationId] });
    },
  });
}
